import { ActionType } from 'typesafe-actions'

import { emergenciesActionType, emergenciesActions } from './actions'
import { Emergency, EmergenciesFilters } from './emergencies'

export interface EmergenciesState {
  readonly error: Error
  readonly isLoading: boolean
  readonly emergencies: Emergency[]
  readonly emergency: Emergency
  readonly totalCount: number
  readonly currentPage: number
  readonly pageSize: number
  readonly filters: EmergenciesFilters
}

export const initialState: EmergenciesState = {
  error: null,
  isLoading: false,
  emergencies: [],
  emergency: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 50,
  filters: {
    dateFrom: null,
    dateTo: null,
    stationId: null,
  },
}

export const emergenciesReducer = (
  state: EmergenciesState = initialState,
  action: ActionType<typeof emergenciesActions>
) => {
  switch (action.type) {
    case emergenciesActionType.FETCH_EMERGENCIES:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case emergenciesActionType.FETCH_EMERGENCIES_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
        emergencies: action.payload.emergencies,
        totalCount: action.payload.totalCount || 0,
      }
    case emergenciesActionType.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload.page,
      }
    case emergenciesActionType.SET_FILTERS:
      return {
        ...state,
        filters: action.payload.filters,
      }
    case emergenciesActionType.RESET_EMERGENCIES:
      return {
        ...state,
        emergencies: [],
        totalCount: 0,
      }
    case emergenciesActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}
